// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__gVQ7z","title":"NotFound_title__nvxU6","text":"NotFound_text__OfBlj","link":"NotFound_link__5v2U5"};